module.exports = __webpack_public_path__ + "static/media/cart.9e0ad0e6.PNG";